<template>
		<div>
			<div class="crumbs">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/monitorSCAList' }">
						<i class="el-icon-time"></i> 视频开放时间模板
					</el-breadcrumb-item>
					<el-breadcrumb-item>编辑视频开放时间模板</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="container">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
					<!-- 所属幼儿园 -->
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'所属幼儿园'" prop="scaSAAI">
								<el-select v-model="ruleForm.scaSAAI" clearable :placeholder="'请选择幼儿园'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsSAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 模板名称 -->
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'模板名称'" prop="scaNAME">
								<el-input v-model="ruleForm.scaNAME" :placeholder="'请输入模板名称'" maxlength="10"></el-input>
							</el-form-item>
						</el-col>
					</el-row> 
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'模板简介'" prop="scaNOTE">
								<el-input type="textarea" v-model="ruleForm.scaNOTE" :placeholder="'请输入模板简介'" maxlength="50"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 视频开放时间段设置 -->
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'视频开放时间段设置'">
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek1" @change="handelWeek1Change">周一</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek1" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek1" @focus="timeStatFocus1(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek1[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek1[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek1" @focus="timeStatFocus1(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek1[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek1[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek1[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek1" @focus="timeFocus1(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek1[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek1[index].scbSTD,
														maxTime:ruleForm.listWeek1[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek1" @focus="timeFocus1(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek1[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek1[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek1[index].scbSTD,
														maxTime:ruleForm.listWeek1[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week1(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week1(index)"></el-button>
													</el-col>
												</el-row>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek2" @change="handelWeek2Change">周二</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek2" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek2" @focus="timeStatFocus2(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek2[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek2[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek2" @focus="timeStatFocus2(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek2[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek2[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek2[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek2" @focus="timeFocus2(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek2[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek2[index].scbSTD,
														maxTime:ruleForm.listWeek2[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek2" @focus="timeFocus2(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek2[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek2[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek2[index].scbSTD,
														maxTime:ruleForm.listWeek2[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week2(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week2(index)"></el-button>
													</el-col>
												</el-row>
											</div>	
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek3" @change="handelWeek3Change">周三</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek3" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek3" @focus="timeStatFocus3(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek3[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek3[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek3" @focus="timeStatFocus3(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek3[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek3[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek3[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek3" @focus="timeFocus3(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek3[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek3[index].scbSTD,
														maxTime:ruleForm.listWeek3[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek3" @focus="timeFocus3(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek3[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek3[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek3[index].scbSTD,
														maxTime:ruleForm.listWeek3[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week3(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week3(index)"></el-button>
													</el-col>
												</el-row>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek4" @change="handelWeek4Change">周四</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek4" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek4" @focus="timeStatFocus4(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek4[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek4[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek4" @focus="timeStatFocus4(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek4[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek4[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek4[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek4" @focus="timeFocus4(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek4[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek4[index].scbSTD,
														maxTime:ruleForm.listWeek4[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek4" @focus="timeFocus4(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek4[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek4[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek4[index].scbSTD,
														maxTime:ruleForm.listWeek4[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week4(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week4(index)"></el-button>
													</el-col>
												</el-row>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek5" @change="handelWeek5Change">周五</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek5" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek5" @focus="timeStatFocus5(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek5[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek5[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek5" @focus="timeStatFocus5(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek5[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek5[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek5[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek5" @focus="timeFocus5(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek5[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek5[index].scbSTD,
														maxTime:ruleForm.listWeek5[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek5" @focus="timeFocus5(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek5[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek5[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek5[index].scbSTD,
														maxTime:ruleForm.listWeek5[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week5(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week5(index)"></el-button>
													</el-col>
												</el-row>
											</div>		
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek6" @change="handelWeek6Change">周六</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek6" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek6" @focus="timeStatFocus6(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek6[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek6[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek6" @focus="timeStatFocus6(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek6[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek6[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek6[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek6" @focus="timeFocus6(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek6[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek6[index].scbSTD,
														maxTime:ruleForm.listWeek6[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek6" @focus="timeFocus6(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek6[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek6[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek6[index].scbSTD,
														maxTime:ruleForm.listWeek6[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week6(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week6(index)"></el-button>
													</el-col>
												</el-row>
											</div>	
										</el-col>
									</el-row>
								</div>
								<div class="sborder">
									<el-row>
										<el-col :span="1" style="text-align: right; margin-top: 5px;">
											<el-checkbox v-model="ruleForm.chkWeek7" @change="handelWeek7Change">周日</el-checkbox>
										</el-col>
										<el-col :span="23">
											<div v-for="(week, index) in ruleForm.listWeek7" :key='index'>
												<el-row>
													<el-col :span="18">
													 <el-form-item label="开放时间段">
														<el-time-select :disabled="ruleForm.disWeek7" @focus="timeStatFocus7(index)" v-if="index==0" placeholder="开始时间" v-model="ruleForm.listWeek7[index].scbSTD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek7[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek7" @focus="timeStatFocus7(index)" v-else placeholder="开始时间" v-model="ruleForm.listWeek7[index].scbSTD" :picker-options="{
														start: ruleForm.listWeek7[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														maxTime:ruleForm.listWeek7[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														至
														<el-time-select :disabled="ruleForm.disWeek7" @focus="timeFocus7(index)" v-if="index==0" placeholder="结束时间" v-model="ruleForm.listWeek7[index].scbEDD" :picker-options="{
														start: '00:00',
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek7[index].scbSTD,
														maxTime:ruleForm.listWeek7[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
														<el-time-select :disabled="ruleForm.disWeek7" @focus="timeFocus7(index)" v-else placeholder="结束时间" v-model="ruleForm.listWeek7[index].scbEDD" :picker-options="{
														start: ruleForm.listWeek7[index-1].scbEDD,
														step: '00:15',
														end: '23:59',
														minTime: ruleForm.listWeek7[index].scbSTD,
														maxTime:ruleForm.listWeek7[index].scbEDD
														}"
														class="handle-select-y">
														</el-time-select>
													 </el-form-item>
													</el-col>
													<el-col :span="3">
														<el-button type="primary" icon="el-icon-plus" size="mini" circle @click="plus_Week7(index)"></el-button>
														<el-button type="warning" icon="el-icon-minus" size="mini" circle @click="minus_Week7(index)"></el-button>
													</el-col>
												</el-row>
											</div>	
										</el-col>
									</el-row>
								</div>
							</el-form-item>
						</el-col>
					</el-row>		
					<el-row>
						<el-col :span="23">
							<el-form-item :label="'删除状态'" prop="scaDELF">
								<el-select v-model="ruleForm.scaDELF" clearable :placeholder="'请选择删除状态'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsDELF" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<div class="submit">
								<el-form-item>
									<el-button @click="goBack()" class="goback">返回</el-button>
									<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
								</el-form-item>
							</div>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
</template>

<script>
	export default {
		name: 'editMonitorSCA',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入视频模板名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkSCANAME(value);
					if (this.isRepeat == true) {
						callback(new Error('视频模板名称重复'));
					} else {
						callback();
					}
				}
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				
				isRepeat: false,
				ruleForm: {
					scaMSID: '',
					scaSAAI: '',
					optionsSAAI: [], //所属幼儿园
					scaNAME: '', //模板名称
					scaNOTE: '', //模板简介
						
					chkWeek1:false,
					chkWeek2:false,
					chkWeek3:false,
					chkWeek4:false,
					chkWeek5:false,
					chkWeek6:false,
					chkWeek7:false,
					
					disWeek1: true,
					disWeek2: true,
					disWeek3: true,
					disWeek4: true,
					disWeek5: true,
					disWeek6: true,
					disWeek7: true,
					
					listWeek1: [{
						scbSTD:'',
						scbEDD: ''
					}], //周一
					listWeek2: [{
						scbSTD:'',
						scbEDD: ''
					}], //周二
					listWeek3: [{
						scbSTD:'',
						scbEDD: ''
					}], //周三
					listWeek4: [{
						scbSTD:'',
						scbEDD: ''
					}], //周四
					listWeek5: [{
						scbSTD:'',
						scbEDD: ''
					}], //周五
					listWeek6: [{
						scbSTD:'',
						scbEDD: ''
					}], //周六
					listWeek7: [{
						scbSTD:'',
						scbEDD: ''
					}], //周日
					
					scaDELF: ''
				},
				rules: {
					scaSAAI: [{
						required: true,
						message: '请选择幼儿园',
						trigger: ['blur', 'change']
					}],
					scaNAME: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}]
				}
			};
		},
		created() {
			this.ruleForm.scaMSID = this.$route.query.SCAMSID;
			this.getDELF(); //获取删除状态
			this.getData(this.ruleForm.scaMSID);
			this.getSAAI(); //幼儿园
			
			this.getSCB(this.ruleForm.scaMSID);
		},
		methods: {
			dummyCreated() {
				this.ruleForm.scaMSID = this.$route.query.SCAMSID;
				this.getDELF(); //获取删除状态
				this.getData(this.ruleForm.scaMSID);
				this.getSAAI(); //幼儿园
				
				this.getSCB(this.ruleForm.scaMSID);
			},
			getData(scaMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcSCA.svc/GET_SCA_BYID';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self.web_sphon,
						sSCAMSID: scaMSID //模板ID
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resStatus = response.status;
					if (resStatus == "200") { //网络请求成功
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							//返回列信息赋值到页面上 
							self.ruleForm.scaSAAI = response.data.KKDT[0].SCASAAI;
							self.ruleForm.scaNAME = response.data.KKDT[0].SCANAME;
							self.ruleForm.scaNOTE = response.data.KKDT[0].SCANOTE;	
							self.ruleForm.scaDELF = response.data.KKDT[0].SCADELF;
						} 
						else {
							this.$message({
								message: '获取数据失败', //无数据
								type: 'error'
							});
						}
					} 
					else {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求获取数据失败', //请求失败
						type: 'error'
					});
				});
			},
			getSCB(scaMSID){
				const self = this;
				var postUrl = 'WCF/WEB/svcSCA.svc/GET_SCB_LIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon,
							sSCBSCAI: scaMSID//模板ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
			
						if (resCount > 0){
							
							let optionsWeek = response.data.KKDT;
							
							//console.log(optionsWeek)
							
							optionsWeek.forEach((subitem, index) => {			
								let scbTYPE=subitem.SCBTYPE;
	
								if(scbTYPE==='1')
								{
									this.ruleForm.listWeek1.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									if(this.ruleForm.listWeek1.length>0){	
										this.ruleForm.chkWeek1 = true;
										this.ruleForm.disWeek1 = false;
									}
								}
 
								if(scbTYPE==='2')
								{
									this.ruleForm.listWeek2.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek2.length>0){
										this.ruleForm.chkWeek2 = true;
										this.ruleForm.disWeek2 = false;
									}
								}
	
								if(scbTYPE==='3')
								{
									this.ruleForm.listWeek3.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek3.length>0){
										this.ruleForm.chkWeek3 = true;
										this.ruleForm.disWeek3 = false;
									}
								}
								
								if(scbTYPE==='4')
								{
									this.ruleForm.listWeek4.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek4.length>0){
										this.ruleForm.chkWeek4 = true;
										this.ruleForm.disWeek4 = false;
									}
								}
								
								if(scbTYPE==='5')
								{
									this.ruleForm.listWeek5.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek5.length>0){
										this.ruleForm.chkWeek5 = true;
										this.ruleForm.disWeek5 = false;
									}
								}
								
								if(scbTYPE==='6')
								{
									this.ruleForm.listWeek6.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek6.length>0){
										this.ruleForm.chkWeek6 = true;
										this.ruleForm.disWeek6 = false;
									}
								}
								
								if(scbTYPE==='7')
								{
									this.ruleForm.listWeek7.push({
										scbSTD: subitem.SCBSTAT, // 开始时间
										scbEDD: subitem.SCBEDDT // 结束时间
									})
									
									if(this.ruleForm.listWeek7.length>0){
										this.ruleForm.chkWeek7 = true;
										this.ruleForm.disWeek7 = false;
									}
								}
							})
							
							if(this.ruleForm.listWeek1.length>1){
								this.ruleForm.listWeek1.shift();
							}
							
							if(this.ruleForm.listWeek2.length>1){
								this.ruleForm.listWeek2.shift();
							}
							
							if(this.ruleForm.listWeek3.length>1){
								this.ruleForm.listWeek3.shift();
							}
							
							if(this.ruleForm.listWeek4.length>1){
								this.ruleForm.listWeek4.shift();
							}
							
							if(this.ruleForm.listWeek5.length>1){
								this.ruleForm.listWeek5.shift();
							}
							
							if(this.ruleForm.listWeek6.length>1){
								this.ruleForm.listWeek6.shift();
							}
							
							if(this.ruleForm.listWeek7.length>1){
								this.ruleForm.listWeek7.shift();
							}
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			handelWeek1Change(){
				if(this.ruleForm.disWeek1)
				{
					this.ruleForm.disWeek1=false;
				}
				else{
					this.ruleForm.disWeek1=true;
					
					this.ruleForm.listWeek1[0].scbSTD='';
					this.ruleForm.listWeek1[0].scbEDD='';
					this.ruleForm.listWeek1.length = 1;		
				}
			},
			handelWeek2Change(){
				if(this.ruleForm.disWeek2)
				{
					this.ruleForm.disWeek2=false;
				}
				else{
					this.ruleForm.disWeek2=true;
					
					this.ruleForm.listWeek2[0].scbSTD='';
					this.ruleForm.listWeek2[0].scbEDD='';
					this.ruleForm.listWeek2.length = 1;
				}
			},
			handelWeek3Change(){
				if(this.ruleForm.disWeek3)
				{
					this.ruleForm.disWeek3=false;
				}
				else{
					this.ruleForm.disWeek3=true;
					
					this.ruleForm.listWeek3[0].scbSTD='';
					this.ruleForm.listWeek3[0].scbEDD='';
					this.ruleForm.listWeek3.length = 1;
				}
			},
			handelWeek4Change(){
				if(this.ruleForm.disWeek4)
				{
					this.ruleForm.disWeek4=false;
				}
				else{
					this.ruleForm.disWeek4=true;
					
					this.ruleForm.listWeek4[0].scbSTD='';
					this.ruleForm.listWeek4[0].scbEDD='';
					this.ruleForm.listWeek4.length = 1;
				}
			},
			handelWeek5Change(){
				if(this.ruleForm.disWeek5)
				{
					this.ruleForm.disWeek5=false;
				}
				else{
					this.ruleForm.disWeek5=true;
					
					this.ruleForm.listWeek5[0].scbSTD='';
					this.ruleForm.listWeek5[0].scbEDD='';
					this.ruleForm.listWeek5.length = 1;
				}
			},
			handelWeek6Change(){
				if(this.ruleForm.disWeek6)
				{
					this.ruleForm.disWeek6=false;
				}
				else{
					this.ruleForm.disWeek6=true;
					
					this.ruleForm.listWeek6[0].scbSTD='';
					this.ruleForm.listWeek6[0].scbEDD='';
					this.ruleForm.listWeek6.length = 1;
				}
			},
			handelWeek7Change(){
				if(this.ruleForm.disWeek7)
				{
					this.ruleForm.disWeek7=false;
				}
				else{
					this.ruleForm.disWeek7=true;
					
					this.ruleForm.listWeek7[0].scbSTD='';
					this.ruleForm.listWeek7[0].scbEDD='';
					this.ruleForm.listWeek7.length = 1;
				}
			},
			//加减执行方法
			plus_Week1(index) {
				
				let strWeek1_scbSTD = this.ruleForm.listWeek1[index].scbSTD;
				let strWeek1_scbEDD = this.ruleForm.listWeek1[index].scbEDD;
				
				if(strWeek1_scbSTD ==='' || strWeek1_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}

				if(this.ruleForm.listWeek1.length<5)
				{	
					this.ruleForm.listWeek1.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week1(index) {		
				if(this.ruleForm.listWeek1.length > 1){
					this.ruleForm.listWeek1.splice(index,1)
				}	
			},
			timeStatFocus1(index) {
				this.ruleForm.listWeek1[index].scbSTD="";
			},
			timeFocus1(index) {
				let listWeek1_len = this.ruleForm.listWeek1.length-1;

				if(index === listWeek1_len)
				{	
					this.ruleForm.listWeek1[index].scbEDD="";
				}
			},
			plus_Week2(index) {
				
				let strWeek2_scbSTD = this.ruleForm.listWeek2[index].scbSTD;
				let strWeek2_scbEDD = this.ruleForm.listWeek2[index].scbEDD;
				
				if(strWeek2_scbSTD ==='' || strWeek2_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}

				if(this.ruleForm.listWeek2.length<5)
				{
					this.ruleForm.listWeek2.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week2(index) {
				if(this.ruleForm.listWeek2.length> 1){
					this.ruleForm.listWeek2.splice(index,1)
				}	
			},
			timeStatFocus2(index) {
				this.ruleForm.listWeek2[index].scbSTD="";
			},
			timeFocus2(index) {
				let listWeek2_len = this.ruleForm.listWeek2.length-1;
				
				if(index === listWeek2_len)
				{	
					this.ruleForm.listWeek2[index].scbEDD="";
				}
			},
			plus_Week3(index) {
				let strWeek3_scbSTD = this.ruleForm.listWeek3[index].scbSTD;
				let strWeek3_scbEDD = this.ruleForm.listWeek3[index].scbEDD;
				
				if(strWeek3_scbSTD ==='' || strWeek3_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}
		
				if(this.ruleForm.listWeek3.length<5)
				{		
					this.ruleForm.listWeek3.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week3(index) {
				if(this.ruleForm.listWeek3.length > 1){
					this.ruleForm.listWeek3.splice(index,1)
				}	
			},
			timeStatFocus3(index) {
				this.ruleForm.listWeek3[index].scbSTD="";
			},
			timeFocus3(index) {
				let listWeek3_len = this.ruleForm.listWeek3.length-1;
				
				if(index === listWeek3_len)
				{	
					this.ruleForm.listWeek3[index].scbEDD="";
				}
			},
			plus_Week4(index){
				let strWeek4_scbSTD = this.ruleForm.listWeek4[index].scbSTD;
				let strWeek4_scbEDD = this.ruleForm.listWeek4[index].scbEDD;
				
				if(strWeek4_scbSTD ==='' || strWeek4_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}	
					
				if(this.ruleForm.listWeek4.length<5)
				{		
					this.ruleForm.listWeek4.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week4(index) {
				if(this.ruleForm.listWeek4.length > 1){
					this.ruleForm.listWeek4.splice(index,1)
				}	
			},
			timeStatFocus4(index) {
				this.ruleForm.listWeek4[index].scbSTD="";
			},
			timeFocus4(index) {
				let listWeek4_len = this.ruleForm.listWeek4.length-1;
				
				if(index === listWeek4_len)
				{	
					this.ruleForm.listWeek4[index].scbEDD="";
				}
			},
			plus_Week5(index) {
				let strWeek5_scbSTD = this.ruleForm.listWeek5[index].scbSTD;
				let strWeek5_scbEDD = this.ruleForm.listWeek5[index].scbEDD;
				
				if(strWeek5_scbSTD ==='' || strWeek5_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}	
					
				if(this.ruleForm.listWeek5.length<5)
				{		
					this.ruleForm.listWeek5.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week5(index) {
				if(this.ruleForm.listWeek5.length > 1){
					this.ruleForm.listWeek5.splice(index,1)
				}	
			},
			timeStatFocus5(index) {
				this.ruleForm.listWeek5[index].scbSTD="";
			},
			timeFocus5(index) {
				let listWeek5_len = this.ruleForm.listWeek5.length-1;
				
				if(index === listWeek5_len)
				{	
					this.ruleForm.listWeek5[index].scbEDD="";
				}
			},
			plus_Week6(index) {
				let strWeek6_scbSTD = this.ruleForm.listWeek6[index].scbSTD;
				let strWeek6_scbEDD = this.ruleForm.listWeek6[index].scbEDD;
				
				if(strWeek6_scbSTD ==='' || strWeek6_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}	
					
				if(this.ruleForm.listWeek6.length<5)
				{		
					this.ruleForm.listWeek6.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week6(index) {
				if(this.ruleForm.listWeek6.length > 1){
					this.ruleForm.listWeek6.splice(index,1)
				}	
			},
			timeStatFocus6(index) {
				this.ruleForm.listWeek6[index].scbSTD="";
			},
			timeFocus6(index) {
				let listWeek6_len = this.ruleForm.listWeek6.length-1;
				
				if(index === listWeek6_len)
				{	
					this.ruleForm.listWeek6[index].scbEDD="";
				}
			},
			plus_Week7(index) {
				let strWeek7_scbSTD = this.ruleForm.listWeek7[index].scbSTD;
				let strWeek7_scbEDD = this.ruleForm.listWeek7[index].scbEDD;
				
				if(strWeek7_scbSTD ==='' || strWeek7_scbEDD===''){
					this.$message({
						message: '请输入开始时间和结束时间', //请输入开始时间和结束时间
						type: 'warning'
					});
					return;
				}	
					
	
				if(this.ruleForm.listWeek7.length<5)
				{							
					this.ruleForm.listWeek7.push({
						scbSTD: '', // 开放时间段-开始
						scbEDD: ''  // 开放时间段-结束
					})
				}
			},
			minus_Week7(index) {
				if(this.ruleForm.listWeek7.length > 1){
					this.ruleForm.listWeek7.splice(index,1)
				}	
			},
			timeStatFocus7(index) {
				this.ruleForm.listWeek7[index].scbSTD="";
			},
			timeFocus7(index) {
				let listWeek7_len = this.ruleForm.listWeek7.length-1;
				
				if(index === listWeek7_len)
				{	
					this.ruleForm.listWeek7[index].scbEDD="";
				}
			},
			//获取幼儿园信息
			getSAAI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon //web侧 登录邮箱
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSAAI = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取幼儿园请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//视频开放时间模板编辑
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
					
						let strchkWeek1=[];
						let strchkWeek2=[];
						let strchkWeek3=[];
						let strchkWeek4=[];
						let strchkWeek5=[];
						let strchkWeek6=[];
						let strchkWeek7=[];
					
						//判断周一是否被选中
						if(this.ruleForm.chkWeek1)
						{
							strchkWeek1=self.ruleForm.listWeek1;
						}
						
						//判断周二是否被选中
						if(this.ruleForm.chkWeek2)
						{
							strchkWeek2=self.ruleForm.listWeek2;
						}
						
						//判断周三是否被选中
						if(this.ruleForm.chkWeek3)
						{
							strchkWeek3=self.ruleForm.listWeek3;
						}
						
						//判断周四是否被选中
						if(this.ruleForm.chkWeek4)
						{
							strchkWeek4=self.ruleForm.listWeek4;
						}
						
						//判断周五是否被选中
						if(this.ruleForm.chkWeek5)
						{
							strchkWeek5=self.ruleForm.listWeek5;
						}
						
						//判断周六是否被选中
						if(this.ruleForm.chkWeek6)
						{
							strchkWeek6=self.ruleForm.listWeek6;
						}
						
						//判断周日是否被选中
						if(this.ruleForm.chkWeek7)
						{
							strchkWeek7=self.ruleForm.listWeek7;
						}
					
						var postUrl = 'WCF/WEB/svcSCA.svc/UPD_SCA';
						//网络请求接口
						this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
								sSCAMSID: self.ruleForm.scaMSID, //模板ID
								sSCASAAI: self.ruleForm.scaSAAI, //所属幼儿园
								sSCANAME: self.ruleForm.scaNAME, //模板名称
								sSCANOTE: self.ruleForm.scaNOTE, //模板简介
								sSCADELF: self.ruleForm.scaDELF, //删除状态
								sSCAWEEK1: JSON.stringify(strchkWeek1), //周一
								sSCAWEEK2: JSON.stringify(strchkWeek2), //周二
								sSCAWEEK3: JSON.stringify(strchkWeek3), //周三
								sSCAWEEK4: JSON.stringify(strchkWeek4), //周四
								sSCAWEEK5: JSON.stringify(strchkWeek5), //周五
								sSCAWEEK6: JSON.stringify(strchkWeek6), //周六
								sSCAWEEK7: JSON.stringify(strchkWeek7)  //周日
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;
				
							if (resStatus == "200") {
								if (resKKSTR == "N") {
									this.$message({
										message: '编辑视频开放时间模板失败', 
										type: 'error'
									});
								} else if (resKKSTR == "Y") {
									this.$message.success('编辑视频开放时间模板成功'); 
									this.$router.push('/monitorSCAList')  // 跳转路由
									this.$bus.$emit('change') 	//子组件可以使用$emit触发父组件的自定义事件 reload
								}
							} else {
								this.$message({
									message: '编辑视频开放时间模板请求失败', 
									type: 'error'
								});
							}
						})
						.catch((error) => {
							this.$message({
								message: '编辑视频开放时间模板请求失败', 
								type: 'error'
							});
						});
					} else {
						this.$message({
							message: '提交失败', 
							type: 'error'
						});
					}
				});
			},
			//验证此幼儿园下，视频名称是否重复
			checkSCANAME(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSCA.svc/CHECK_SCA_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.scaSAAI,
						sSCAID: self_shop.ruleForm.scaMSID,
						sSCANM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					//console.log("aaaaa:" + response.data.KKSTR);
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取幼儿园请求失败', //请求失败
						type: 'error'
					});
		
				});
			},
			//获取删除信息
			getDELF() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10005 //删除 10005
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleForm.optionsDELF = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取删除状态请求失败', //请求失败
						type: 'error'
					});
		
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editMonitorSCA") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.font {
		font-size: 14px;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.submit {
		margin-top: 50px;
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.handle-select-y {
		width: 45%;
	}
	.sborder{
		width: 60%; 
		border: 1px solid #DCDFE6; 
		border-radius: 4px 0 0 4px; 
		margin: 10px;
		padding-top: 15px;
		padding-left: 50px;
	}
</style>
